// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"626":"7656e22b","1752":"9581f0c0","3327":"9581f0c0","9897":"9581f0c0"}[chunkId] + ".chunk.css";
};